import { useState } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMyOrg } from "@/hooks/use-my-org";
import { useModuleOffers } from "./useModuleOffers";
import { ModuleOfferSummary } from "./ModuleOfferSummary";
import {
  ModuleOfferPageControls,
  ModuleOfferReadError,
  ModuleOfferWorkspace,
} from "./ModuleOfferWorkspace";

export function ModuleOffersPage() {
  const org = useMyOrg();
  const [offset, setOffset] = useState(0);
  const orgId = org.kind === "error" ? undefined : org.org?.org_id;
  const query = useModuleOffers(orgId, { offset });
  return (
    <ModuleOfferWorkspace title="Module offers">
      {org.kind === "loading" || (orgId && query.isPending) ? (
        <Typography role="status">Loading module offers…</Typography>
      ) : !orgId || query.isError ? (
        <ModuleOfferReadError onRetry={() => void query.refetch()} />
      ) : query.data ? (
        <Stack spacing={2}>
          {!query.data.items.length ? (
            <Typography>{query.data.total === 0 && query.data.offset === 0
              ? "No module offers are available right now."
              : "No module offers on this page."}</Typography>
          ) : (
            query.data.items.map((offer) => <ModuleOfferSummary key={offer.offer_version_id} offer={offer} />)
          )}
          <ModuleOfferPageControls page={query.data} onOffset={setOffset} />
        </Stack>
      ) : null}
    </ModuleOfferWorkspace>
  );
}
